export default "__VITE_ASSET__CSxm8jgL__"